import { Request } from "@konv/http";
import { UserStorage } from "../shared/tools/UserStorage";

export class CustomerAPI {
  static async request({
    endpoint = "/",
    method = "GET",
    headers,
    query,
    data,
  }) {
    return await Request.request({
      endpoint: endpoint,
      method: method,
      headers: headers,
      service: "customers",
      ignoreVersion: true,
      params: query,
      data: data,
    });
  }

  static async requestAuthenticated({
    endpoint = "/",
    method = "GET",
    query,
    data,
  }) {
    return await CustomerAPI.request({
      endpoint,
      headers: { Authorization: "Bearer " + UserStorage.getAccessToken() },
      method,
      query,
      data,
    });
  }

  static async getCustomers({ term, offset, limit }) {
    return await CustomerAPI.requestAuthenticated({
      endpoint: "/",
      method: "GET",
      query: {
        term,
        offset,
        limit,
      },
    });
  }

  static async resetPassword(customerId) {
    return await CustomerAPI.requestAuthenticated({
      endpoint: `/${customerId}/password-reset`,
      method: "POST",
    });
  }

  static async confirmLogin(customerId) {
    return await CustomerAPI.requestAuthenticated({
      endpoint: `/${customerId}/validations`,
      method: "POST",
    });
  }

  static async getCustomer(term) {
    return await CustomerAPI.requestAuthenticated({
      endpoint: "/olga/autocomplete",
      method: "GET",
      query: {
        term,
        limit: 5,
      },
    });
  }

  static async postCustomerById(customerId) {
    return await CustomerAPI.requestAuthenticated({
      endpoint: `/olga/${customerId}/resolve`,
      method: "POST",
    });
  }

  static async getCustomerById(customerId) {
    return await CustomerAPI.requestAuthenticated({
      endpoint: `/${customerId}`,
      method: "GET",
    });
  }

  static async createCustomer(customer) {
    return await CustomerAPI.requestAuthenticated({
      endpoint: "/olga",
      method: "POST",
      data: customer,
    });
  }

  static async updateCustomer(customerId, customer) {
    const endpoint = `/${customerId}`;
    return await CustomerAPI.requestAuthenticated({
      endpoint,
      method: "PUT",
      data: customer,
    });
  }
}
